// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mute-toggle{display:none;position:absolute;right:10px;bottom:46px;opacity:1;z-index:199}.mute-toggle i{color:#d7dae4;font-size:30px}.mute-toggle:hover{opacity:.8}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
